import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

/* eslint-disable react-refresh/only-export-components -- Provider + hook xuất cùng file */

type MapLeftSidebarHostContextValue = {
  leftSidebarContent: ReactNode | null;
  setLeftSidebarContent: (node: ReactNode | null) => void;
};

const MapLeftSidebarHostContext = createContext<MapLeftSidebarHostContextValue | null>(null);

/**
 * Hosts the left analysis sidebar DOM registered by 2D/3D map views so
 * {@link DashboardLayout} can render it in the fixed rail and mobile Drawer without prop drilling.
 */
export function MapLeftSidebarHostProvider({ children }: { children: ReactNode }) {
  const [leftSidebarContent, setLeftSidebarContentState] = useState<ReactNode | null>(null);

  const setLeftSidebarContent = useCallback((node: ReactNode | null) => {
    setLeftSidebarContentState(node);
  }, []);

  const value = useMemo(
    () => ({ leftSidebarContent, setLeftSidebarContent }),
    [leftSidebarContent, setLeftSidebarContent],
  );

  return (
    <MapLeftSidebarHostContext.Provider value={value}>
      {children}
    </MapLeftSidebarHostContext.Provider>
  );
}

export function useMapLeftSidebarHost(): MapLeftSidebarHostContextValue {
  const ctx = useContext(MapLeftSidebarHostContext);
  if (!ctx) {
    throw new Error('useMapLeftSidebarHost must be used within MapLeftSidebarHostProvider');
  }
  return ctx;
}
